module.exports = __webpack_public_path__ + "img/sustell.8d9edb43.png";